export default "__VITE_ASSET__08dfd54e__"